<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :to="{ name: 'New User', params: { role: 'admin' }}"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="admin-count" >
                     {{ selectedItems.length > 0 ? selectedItems.length + ' Admins Selected.' : total + ' Admins Found.' }}
                </v-toolbar-title>
                <v-btn class="ml-3" tile color="primary" small v-if="selectedItems.length > 0" @click="selectAll">Select All</v-btn>
                <v-btn class="primary--text" tile color="#ffffff" small v-if="selectedItems.length > 0" @click="deselectAll">Deselect All</v-btn>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-list two-line tile flat class="py-0 hover-list">
                <template v-for="(admin, index) in admins">
                    <v-list-item
                    :key="`admin-${index}`"
                    :value="admin.id"                 
                    >
                        <template>
                            <v-list-item-content @click.stop="openLead(admin.id)">
                                <v-list-item-title v-html="admin.name"></v-list-item-title>
                                <div>
                                    <template v-for="(role, i) in admin.roles">
                                        <v-chip
                                        :color="getColor(role.name)"
                                        class="mr-2"
                                        text-color="white"
                                        small
                                        label
                                        :key="`chip-${admin.id}-${i}`"
                                        >
                                            {{ role.name | separate }}
                                        </v-chip>
                                    </template>
                                <div>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-list-item-icon class="ma-0 w-100">
                                    <v-btn small color="primary" :to="{ path: '/user/'+ admin.id }" tile elevation="0">Edit</v-btn>
                                </v-list-item-icon>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                    <v-divider
                    :key="`dv-${index}`"
                    ></v-divider>
                </template>
                <v-list-item v-if="pagination.total > 1">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
        <FilterDrawer :show="drawer" :filter="filter" :routekey="routeKey" @update-schedule="updateSchedule" @update-status="updateStatus" @update-assign="updateAssign" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @update-phone="updatePhone" @update-daterange="updateDaterange" @submit-search="submitSearch"/>
        <Mail :show="newMail" :recepients="selectedItems" @close-mail="newMail = false"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterDrawer from '../components/FilterUsers.vue'

export default {
    data() {
        return {
            newMail: false,
            selectedItems: [],
            drawer: false,
            loading: true,
            admins: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                keyword: "",
            },
            total: 0,
            all: [],
            stats: []
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        this.getadmins()
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else {
                return this.pageTitle
            }
        },
    },
    components: {
        FilterDrawer
    },
    methods: {
        getadmins() {
            this.loading = true
            this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.admins = response.data.admins.data
                this.pagination.current = response.data.admins.current_page
                this.pagination.total = response.data.admins.last_page
                this.total = response.data.admins.total
                this.all = response.data.all
                this.stats = response.data.stats
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getadmins()
            this.$vuetify.goTo(0)
        },
        openLead(id) {
            this.$router.push({ path: '/user/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        openLink (link) {
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        submitSearch() {
            this.getadmins()
        },
        getColor(status) {
            switch(status) {
                case 'admin':
                    return 'green'
                case 'estimator':
                    return 'light-blue'
                case 'cleaner':
                    return 'purple'
                case 'warranty':
                    return 'yellow'
                case 'foreman':
                    return 'blue'
                case 'finishing_crew':
                    return 'pink'            
                default:
                    // code block
            }
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff

.fullscreen
    background: #fff
    height: 100%

.w-100
    width: 100%
    .v-btn 
        width: 100%

.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px

.v-chip 
    border-radius: 0!important

.lead-count
    font-size: 14px
</style>